import $ from 'jquery';

export function onSubmit(token) {
  let $thisRecaptcha = $('.grecaptcha-badge[data-style="bottomright"]'),
    $thisFrom = $thisRecaptcha.parents('form'),
    $thisInput = $thisFrom.find('input[required]:not([type="radio"]), input[required][type="radio"]:checked'),
    $thisInputFit = $thisFrom.find(
      '.input-wrapper.fit:visible, .pw-wrapper.fit:visible, .form-radio-group.fit:visible'
    );

  if ($thisInputFit.length === $thisInput.length) {
    // console.log('total: ' + $thisInput.length + ' | ' + 'fit: ' + $thisInputFit.length);
    $thisFrom.submit();
    // alert('recaptcha submit! ' + 'total: ' + $thisInput.length + ' | ' + 'fit: ' + $thisInputFit.length);
  } else {
    // console.log('total: ' + $thisInput.length + ' | ' + 'fit: ' + $thisInputFit.length);
    grecaptcha.reset();
    // alert('recaptcha reset! ' + 'total: ' + $thisInput.length + ' | ' + 'fit: ' + $thisInputFit.length);
  }

  // alert('recaptcha callback');
}

export function onloadCallback() {
  const $gRecaptcha = $('.g-recaptcha');
  let _gRecaptchaCount = $gRecaptcha.length,
    widgetId = [];

  // console.log(_gRecaptchaCount);

  if (_gRecaptchaCount > 0) {
    for (let i = 0; i < _gRecaptchaCount; i++) {
      let $this = $gRecaptcha.eq(i),
        $thisFrom = $this.parents('form'),
        $thisSubmitBtn = $thisFrom.find('.btn-submit'),
        _sitekeyValue = $this.attr('data-sitekey');

      if ($thisFrom.is(':visible')) {
        // console.log('form visible');
        let $thisRecaptchaBadge = $thisFrom.find('.grecaptcha-badge');

        if ($thisRecaptchaBadge.length > 0) {
          // console.log('recaptcha existed');

          // get current recaptcha id
          /*
                    let $thisRecaptchaIframe = $thisRecaptchaBadge.find('iframe[title="reCAPTCHA"]'),
                    _thisRecaptchaName = $thisRecaptchaIframe.attr('name'),
                    _thisRecaptchaNameStr = _thisRecaptchaName.split('-'),
                    _thisRecaptchaId = _thisRecaptchaNameStr[_thisRecaptchaNameStr.length - 1];
                    console.log(_thisRecaptchaId);
                    */
          grecaptcha.reset(widgetId[i]);
        } else {
          // console.log('no recaptcha');
          widgetId[i] = grecaptcha.render(document.querySelectorAll('.g-recaptcha')[i], {
            sitekey: _sitekeyValue,
            callback: onSubmit,
          });
        }

        $thisSubmitBtn.click(function () {
          if ($thisSubmitBtn.is(':disabled')) {
            return false;
          } else {
            grecaptcha.execute(widgetId[i]); // for prd

            // //-- for dev (Remove before deploying to production)
            // if (recaptchaSwitch === 'off') {
            //   // console.log(recaptchaSwitch);
            //   let $thisInput = $thisFrom.find('input[required]:not([type="radio"]), input[required][type="radio"]:checked'),
            //     $thisInputFit = $thisFrom.find(
            //       '.input-wrapper.fit:visible, .pw-wrapper.fit:visible, .form-radio-group.fit:visible'
            //     );

            //   if ($thisInputFit.length === $thisInput.length) {
            //     $thisFrom.submit();
            //   }
            // } else {
            //   grecaptcha.execute(widgetId[i]);
            // }
            // //-- for dev (Remove before deploying to production)
          }
        });
      } else {
        // console.log('form hidden');
        if (widgetId[i]) {
          grecaptcha.reset(widgetId[i]);
        }
        continue;
      }
    }
  } else {
    return 0;
  }
}